import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {Button, Col, Input, List, Row, Tooltip, Upload} from "antd";
import {employeeService} from "api";
import {Notification, PdfViewer} from "components/common";
import React, {useEffect, useRef, useState} from "react";
import {useAppSelector} from "redux/hooks";

const ListFile = props => {
  const {closeModal, activeKey} = props;
  const [filePdf, setFilePdf] = useState();
  const [listFile, setListFile] = useState<any>();
  const [searchTerm, setSearchTerm] = useState(""); // State for search term
  const detailDoc = useAppSelector(state => state.employeesReducer.detailDoc);
  const pdfRef = useRef<any>();

  const getListFile = async () => {
    const res = await employeeService.getListFileOfDoc(detailDoc?.id);
    setListFile(res?.data?.items);
  };

  useEffect(() => {
    if (detailDoc) {
      getListFile();
    } else {
      setListFile([]);
    }
  }, [detailDoc]);
  useEffect(() => {
    console.log(activeKey);
    if (activeKey !== "list-file") {
      setSearchTerm("");
    }
  }, [activeKey]);
  const uploadFile = async (options: any) => {
    const file_size = options.file.size;
    try {
      if (file_size <= 3000000) {
        const formData = new FormData();
        formData.append("files", options.file as Blob);
        formData.append("type", "VAN_BAN_DI");
        formData.append("id", detailDoc?.id);
        const res = await employeeService.uploadFileTextAway(formData);
        getListFile();
        Notification("success", "Đã tải file thành công");
      } else {
        Notification("warning", "Kích thước file vượt quá giới hạn (3MB)");
      }
    } catch (error) {
      Notification(
        "error",
        "Lỗi khi tải file hoặc kích cỡ file đạt quá giới hạn"
      );
    }
    return false;
  };

  const handleDownload = async file => {
    try {
      const blob = await employeeService.getBlobFile(file?.id);
      const link = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = `${file?.tenFile}.${file?.extention}`;
      link.click();
    } catch (error) {}
  };

  const handlePreview = async file => {
    try {
      pdfRef?.current?.openModal();
      const blob = await employeeService.getBlobFile(file?.id);
      setFilePdf(blob);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xem tệp");
    }
  };

  const handleDelete = async item => {
    try {
      await employeeService.deleteFile(item?.id);
      getListFile();
    } catch (error) {
      Notification("error", "Xóa file không thành công");
    }
  };

  // Filter function for search term
  const filteredList = listFile?.filter(item =>
    item.tenFile.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <Input
        placeholder="Nhập tên tệp để tìm kiếm"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        style={{marginBottom: "10px"}}
      />
      <div style={{fontSize: "20px", fontWeight: "bold"}}>
        Tên tệp đã tải lên
        <List
          className="list-item"
          dataSource={filteredList || []} // Use filtered list
          renderItem={(item: any) => (
            <List.Item
              style={{padding: "10px 0"}}
              actions={[
                <Tooltip title="Tải xuống">
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() => handleDownload(item)}
                  />
                </Tooltip>,

                <Tooltip title="Xem chi tiết">
                  <Button
                    icon={<EyeOutlined />}
                    onClick={() => handlePreview(item)}
                  />
                </Tooltip>,
                <Tooltip title="Xóa">
                  <Button
                    type="default"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleDelete(item)}
                  />
                </Tooltip>,
              ]}
            >
              <List.Item.Meta title={<div>{item?.tenFile}</div>} />
            </List.Item>
          )}
        />
      </div>
      <Row justify={"end"} gutter={[16, 16]}>
        <Col>
          <Upload
            customRequest={uploadFile}
            accept=".pdf"
            multiple
            showUploadList={false}
          >
            <Tooltip title="Tải file lên(tối đa 3Mb)">
              <Button
                type="primary"
                className="btn-sub"
                icon={<UploadOutlined />}
              >
                Tải tệp lên từ máy tính
              </Button>
            </Tooltip>
          </Upload>
        </Col>

        <Button type="default" danger onClick={() => closeModal()}>
          Hủy bỏ
        </Button>
      </Row>
      <PdfViewer modalViewer={pdfRef} filePdf={filePdf} />
    </div>
  );
};

export default ListFile;
